var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    viewBox: "0 0 38 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65868 19.959C1.38121 17.8299 1.38121 15.1701 2.65868 13.041V13.041C3.04851 12.3912 3.69433 11.9361 4.4373 11.7875L7.47065 11.1809C7.65136 11.1447 7.81426 11.0478 7.93224 10.9062L13.8791 3.76998C15.0617 2.35092 15.6529 1.64138 16.1806 1.83242C16.7083 2.02346 16.7083 2.94707 16.7083 4.79428L16.7083 28.2057C16.7083 30.0529 16.7083 30.9765 16.1806 31.1676C15.6529 31.3586 15.0617 30.6491 13.8791 29.23L7.93224 22.0938C7.81426 21.9522 7.65136 21.8553 7.47065 21.8191L4.4373 21.2125C3.69433 21.0639 3.04851 20.6088 2.65868 19.959V19.959Z",
    stroke: "#222222",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8346 10.1655C26.5059 11.8369 27.449 14.1011 27.4583 16.4647C27.4677 18.8284 26.5424 21.0999 24.8843 22.7844",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2185 6.36482C34.8927 9.03901 36.4017 12.6617 36.4166 16.4436C36.4315 20.2254 34.9511 23.8599 32.2981 26.5551",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 33 L38 0",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAudioIcon);
export default __webpack_public_path__ + "static/media/notAudioIcon.ba6251017bb425fcc07f221543cf1769.svg";
export { ForwardRef as ReactComponent };